import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const superAdminNotificationsSlice = createAppSlice({
  name: 'superAdminNotifications',
  initialState,
  reducers,
});

export const { getSuperAdminNotifications } = superAdminNotificationsSlice.actions;

export default superAdminNotificationsSlice.reducer;
